export function parseScheduledDate(value) {
  if (value == null || value === "") return null;
  try {
    const seconds = value?.seconds ?? value?._seconds;
    const nanos = value?.nanoseconds ?? value?._nanoseconds ?? 0;
    const date = typeof value?.toDate === "function" ? value.toDate()
      : seconds != null ? new Date(Number(seconds) * 1000 + Math.floor(Number(nanos) / 1e6))
        : new Date(value);
    return date instanceof Date && Number.isFinite(date.getTime()) ? date : null;
  } catch { return null; }
}

export function initialScheduledDate(values = {}, mode = "create") {
  if (mode === "create" && !values.importDraftId && values.activationAt === undefined) return new Date();
  return parseScheduledDate(values.activationAt);
}
